function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import Page from '../base/Page';
import PageComponent from "../base/PageComponent";
var ContactForm = /*#__PURE__*/function (_PageComponent) {
  _inherits(ContactForm, _PageComponent);
  var _super = _createSuper(ContactForm);
  function ContactForm() {
    _classCallCheck(this, ContactForm);
    return _super.apply(this, arguments);
  }
  _createClass(ContactForm, [{
    key: "init",
    value: function init() {
      this.ready();
    }
  }, {
    key: "ready",
    value: function ready() {
      var _this = this;
      var form = this.element.find(".contact-form");
      this.element.on('submit', function (e) {
        e.preventDefault();
        var valid = _this.validate(form);
        if (valid) {
          $.ajax({
            type: "POST",
            url: form.attr('action'),
            data: form.serializeArray(),
            success: function success(data) {
              // console.log(data);
              form.find('.form-group').hide();
              form.find('.form-footer').hide();
              form.find('.contact-form-heading').show();
            }
          });
        }
      });
    }
  }, {
    key: "validate",
    value: function validate(form) {
      var formName = form.find('.contact-name'),
        formEmail = form.find('.contact-email'),
        formMessage = form.find('.contact-message'),
        formRecap = form.find('.hidden-recap'),
        formSubject = form.find('.contact-subject');
      if (formName.length) {
        if ($.trim(formName.val()) == '') {
          formName.addClass('is-invalid').parent().find('.invalid-feedback').show();
          return false;
        } else {
          formName.removeClass('is-invalid').parent().find('.invalid-feedback').hide();
        }
      }
      if (formEmail.length) {
        if (/(.+)@(.+){2,}\.(.+){2,}/.test($.trim(formEmail.val()))) {
          formEmail.removeClass('is-invalid').parent().find('.invalid-feedback').hide();
        } else {
          formEmail.addClass('is-invalid').parent().find('.invalid-feedback').show();
          return false;
        }
      }
      if (formSubject.length) {
        if ($.trim(formSubject.val()) == '') {
          formSubject.addClass('is-invalid').parent().find('.invalid-feedback').show();
          return false;
        } else {
          formSubject.removeClass('is-invalid').parent().find('span').hide();
        }
      }
      if (formMessage.length) {
        if ($.trim(formMessage.val()) == '') {
          formMessage.addClass('is-invalid').parent().find('.invalid-feedback').show();
          return false;
        } else {
          formMessage.removeClass('is-invalid').parent().find('span').hide();
        }
      }
      if (formRecap.length) {
        if ($.trim(formRecap.val()) == '') {
          formRecap.addClass('is-invalid').parent().find('.invalid-feedback').show();
          return false;
        } else {
          formRecap.removeClass('is-invalid').parent().find('.invalid-feedback').hide();
        }
      }
      apa("Submitted_Enquiry");
      return true;
    }
  }]);
  return ContactForm;
}(PageComponent);
export { ContactForm as default };